import HSGModalComponent from "./../../../HSGModalComponent/HSGModalComponent"
import React from "react";

const DataPolicy = ({ show, onClose }) => (

    <HSGModalComponent 
        show={show}
        onClose={()=>onClose()}
        onHide={()=>onClose()}
        header="Data Usage Policy"
        bsSize="large"
        isForm={false}
        body={(
            <div id="modalTermsCondition" aria-labelledby="sorryModalLabel">
                <div>
                    <div>
                        <div>
                            <h3>The HealthSetGo(HSG) Data Usage Policy was updated on 13th Feb, 2026.</h3>
                            This following policy has been created to help the, subscribers, students, parents, care
                            givers, health care professionals, to understand the collection, use, disclosure, transfer,
                            and storage of the Data by HSG.
                            <h3>What forms Data:</h3>
                            <ul>
                                <li>
                                    {" "}
                                    Personal Information and proprietary information which may include: age, contact
                                    information, address, telephone numbers, vital signs, lab reports, medical history
                                    including immunisations, allergies, and current and past medications;
                                </li>
                                <li> your username and password;</li>
                                <li>
                                    {" "}
                                    the content, communications and other information that you provide when you use the
                                    Service, including when you sign up for an account, create or share content, and
                                    message or communicate with others;
                                </li>
                                <li>
                                    {" "}
                                    content, communications and information that other people provide when they use the
                                    Service. This can include information about you, such as when they share or comment
                                    on a photo of you, send a message to you or upload, sync or import your contact
                                    information;
                                </li>
                                <li> all communications with other users of the Service;</li>
                                <li> user communications, feedback, suggestions and ideas;</li>
                                <li> billing information; and</li>
                                <li>
                                    {" "}
                                    information that you provide when you contact or engage platform support regarding
                                    the Service.
                                </li>
                            </ul>
                            <h3>Purpose of Collection</h3>
                            <ul>
                                <li>
                                    {" "}
                                    The foremost purpose of collection of Data is to verify the child connected with the
                                    School with which HealthSetGo has an Agreement to provide health services such as
                                    medical assessments and health history monitoring;
                                </li>
                                <li>
                                    {" "}
                                    If applicable HSG may combine Data to provide and improve its products, services,
                                    and showcase relevant content.
                                </li>
                                <li>
                                    {" "}
                                    Anonymized health queries for CareBot AI responses (third-party AI with consent).
                                </li>
                            </ul>
                            <h3>Use of Data</h3>
                            <ul>
                                <li>
                                    {" "}
                                    communicating with users and administrators regarding their use of the Service;
                                </li>
                                <li>
                                    {" "}
                                    enhancing the security and safety of the Service for you and other users, such as by
                                    investigating suspicious activity or breaches of applicable terms or policies;
                                </li>
                                <li> personalising your experiences as part of our provision of the Service;</li>
                                <li> developing new tools, products or services within the Service for you;</li>
                                <li>
                                    {" "}
                                    associating activity on the Service across different devices operated by the same
                                    individual to improve the overall operation of the Service;
                                </li>
                                <li> to identify and fix bugs that may be present;</li>
                                <li>
                                    {" "}
                                    conducting data and system analytics, including research to improve the Service;
                                </li>
                                <li>
                                    {" "}
                                    for internal purposes such as auditing, data analysis, and research to improve HSG’s
                                    products, services, and customer communications; and
                                </li>
                                <li>
                                    {" "}
                                    Annonymised and De-identified Personal Information may be used for investigation,
                                    detection, researching and searching for solutions, precautions, innovations,
                                    introductions and improvement of health related issues among children.
                                </li>
                            </ul>
                            The Data shall not be reproduced, sold, assigned, licensed, marketed, transferred or
                            otherwise disposed of, given or disclosed to any third parties in the format collected by
                            HSG.

                            <h3>CareBot AI Assistant (Opt-In Feature)</h3>
                            
                                
                                    <p>CareBot is an optional AI-powered health assistant.</p>
                                    When enabled:
                               <ul>
                               
                                    <li> {" "}
                                        User queries (e.g., health questions) are sent to third-party AI services (Google Gemini API) for response generation.</li>
 <li> {" "}
    No personal health data (vitals, medical history) shared; queries anonymized.</li>
 <li> {" "}
    Explicit user consent obtained via notification opt-in before any data sent.</li>
 <li> {" "}
    Users can disable anytime by requesting the support team; data not retained by AI provider.
                                    </li>
                                </ul>

This complies with App Store Guideline 5.1.2(i). Updated: February 13, 2026.

                            <h3>Account closure</h3>
                            <ul>
                                <li>
                                    {" "}
                                    If you would like to stop using the Service, you should contact HSG at
                                    support@healthsetgo.co.in . We will suspend your Account and/or delete any
                                    information associated with your Account.
                                </li>
                                <li>
                                    {" "}
                                    It typically takes about 90 days to delete an account after account closure, but
                                    some information may remain in backup copies for a reasonable period of time.
                                </li>
                            </ul>
                            <h3>Cancellation and Refund Policy</h3>
                            <ul>
                                <li>
                                    {' '}
                                    You can cancel your Subscription at any time. 
                                            Please note the you must cancel your Subscription
                                         before it renews for a subsequent month in order to 
                                         avoid being charged for the next month’s Subscription Fee.
                                          If you cancel your subscription, the cancellation will become 
                                          effective at the end of the then-current monthly subscription 
                                          period.
                                </li>
                                <li>
                                    {" "}
                                    REFUNDS WILL NOT BE PROVIDED FOR ANY SUBSCRIPTION.
                                    WE DO NOT PROVIDE CREDITS, REFUNDS OR PRORATED BILLING FOR
                                    SUBSCRIPTIONS THAT ARE CANCELLED MID-MONTH. 
                                </li>
                            </ul>
                            <h3>Important Terms</h3>
                            <ul>
                                <li>
                                    {" "}
                                    <b>“Agreement”</b> shall mean and refer to the document executed with HSG for
                                    providing Services;
                                </li>
                                <li>
                                    {" "}
                                    <b>“Anonymization”</b> shall mean the process of permanently deleting all personally
                                    identifiable information from an individual’s digital health data;
                                </li>
                                <li>
                                    {" "}
                                    <b>“De-identified”</b> shall means the process of removing, obscuring, redacting or
                                    delinking all personally identifiable information from an individual’s digital
                                    health data in a manner that eliminates the risk of unintended disclosure of the
                                    identity of the owner and such that, if necessary the data may be linked to the
                                    owner again;
                                </li>
                                <li>
                                    {" "}
                                    <b>“Personal information”</b> is the information that can be used to identify or
                                    contact a single person;
                                </li>
                                <li>
                                    {" "}
                                    <b>“Subscribers”</b> are the users of the HSG website;
                                </li>
                                <li>
                                    {" "}
                                    <b>“Service(s)”</b> shall mean the services of HSG as contemplated in the Agreement
                                </li>
                            </ul>
                            <h3>Others</h3>
                            It may be necessary − by law, legal process, litigation, and/or requests from public and
                            governmental authorities by a court order or any similar judicial or semi-judicial order for
                            HSG to disclose your personal information.
                            <h3>Protection of Personal Information</h3>
                            <ul>
                                <li>
                                    {" "}
                                    HSG takes the security of your personal information very seriously. HSG stores all
                                    the Data in a secure amazon cloud. HSG uses protected Amazon RDS service for
                                    database and Amazon S3 bucket for storing documents. Also, all the web applications
                                    are secured with Amazon SSL certificate.
                                </li>
                                <li>
                                    {" "}
                                    HSG may update its Privacy Policy from time to time. When we change the policy in a
                                    material way, a notice will be posted on our website along with the updated Privacy
                                    Policy.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        )}
    />
);


export default DataPolicy